import React, {useContext, useState} from 'react';
import axios from 'axios';
import {Link, useParams} from 'react-router-dom';
import {Alert, Button, Col, Form, InputGroup, Row,Modal} from 'react-bootstrap';
import AuditContext from '../Utils/context.js';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import useNotif from 'hooks/use-notify-hook';

export default function Proof() {

  const {employeeId, scheduleId} = useParams();
  const {schedule} = useContext(AuditContext);
  const [swal, setSwal] = useAlert();
  const [notif, setNotif] = useNotif();
  const [modalShow, setModalShow] = useState(false);
  const [spreadsheet, setSpreadsheet] = useState(``);

  function MyVerticallyCenteredModal(props) {
      return (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <p>Baca dan pahami peringatan pengisian LKPS berikut sebelum mengunduhnya :</p>
            <ol>
              <li>Tidak diperbolehkan mengubah / menghapus struktur tabel yang tersedia dan mewarnai cell/sheet tabs pada LKPS.</li>
              <li>Cell yang tidak diisi agar dikosongkan saja. Mohon tidak mengisi dengan tanda "-" atau tanda lain semisalnya. Isi cell yang berwarna KUNING saja.</li>
              <li>Untuk menambahkan cell baru, sisipkan di kolom area sel berwarna kuning agar perhitungan tetap akurat.</li>
              <li>Pengisian excel LKPS agar menggunakan Microsoft Excel (Asli dari Microsoft) bukan menggunakan software-software sejenis seperti Zoho Sheet, OpenOffice, WPS Office Spreadsheets dan sebagainya karena penggunaan software selain microsoft excel dapat menimbulkan error pada file LKPS yang diisi.</li>
              <li>Bila ada pertanyaan lebih lanjut, hubungi BPMI.</li>
            </ol>
          </Modal.Body>
          <Modal.Footer>
            {schedule.UPDATE_FORM_FILE ?
              <Button href={`${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}/download-template`} onClick={props.onHide} target="_blank">Mengerti</Button>
            :
              <Button href={`${process.env.REACT_APP_API_HOST}instruments/${schedule.instrument.INSTRUMENT_ID}/download-spreadsheet`} onClick={props.onHide} target="_blank">Mengerti</Button>
            }
          </Modal.Footer>
        </Modal>
      );
    }

  function handleOpenInfo(){
    setModalShow(true)
  }

  const getVariant = (form) => {

    if (form.SUBMIT_AT !== null) return 'primary';
    if (form.EVALUATE_AT !== null) return 'success';
    console.log('ini adalah variant');
    console.log(form);
    return 'secondary';
  }

  const handleUploadSpreadsheet = async ({target}) => {

    try {

      let payload = new FormData();
      payload.append('form', target.files[0]);


      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}schedules/${scheduleId}/submit-spreadsheet`,
        payload,
        {headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          "Content-Type": `multipart/form-data; charset=utf-8; boundary="${Math.random().toString().substr(2)});`,
        }}
      );

      setSpreadsheet(target.files[0].name);

      setNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {message: error.toString()}
      });
    }
  }

  return (
    <>
      {swal}
      {notif}
      <h3>Proof Submission</h3>
      {schedule.instrument.FORM_FILE && (
        <Row>
          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
          <Col md={6}>
            <Form.Group>
              <Form.Label>Spreadsheet Template</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control
                  value={schedule.instrument.FORM_FILE.split('/').pop()}
                  readOnly={true}
                />
                <button
                  onClick={handleOpenInfo}
                  className="btn btn-secondary"
                  id="button-addon2"
                >
                  Download
                </button>

                {/* <a href={`${process.env.REACT_APP_API_HOST}instruments/${schedule.instrument.INSTRUMENT_ID}/download-spreadsheet`}
                  className="btn btn-secondary" id="button-addon2"
                >
                  Download
                </a> */}
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={6}>
          <Form.Group>
              <Form.Label>Submitted Spreadsheet</Form.Label>
              <Form.File
                id="report-file"
                custom
                label={spreadsheet || schedule.FORM_FILE?.split('/').pop() || 'N/A'}
                accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                onChange={handleUploadSpreadsheet}
              />
            </Form.Group>
          </Col>
        </Row>
      )}
      <Row>
        {schedule.forms && schedule.forms.map((form, key) => (
          <Col key={key} md={4}>
            <Link to={`/auditee/${employeeId}/proofs/${form.FORM_ID}`}>
              <Button variant={getVariant(form)} style={{textAlign: 'left'}}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
            </Link>
          </Col>
        ))}
      </Row>
    </>
  );
}